export default "__VITE_ASSET__305fd16f__"